import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CookieBanner.css';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  // Only show if user hasn't already responded
  useEffect(() => {
    // Skipped during prerender so the banner is not frozen into every
    // static page; it still appears normally once the app hydrates.
    if (window.__PRERENDER__) return;
    const consent = localStorage.getItem('lp_cookie_consent');
    if (!consent) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem('lp_cookie_consent', 'accepted');
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem('lp_cookie_consent', 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-banner-inner">
        <p className="cookie-text">
          We use local storage to remember your preferences and manage your subscription status.
          No tracking cookies or advertising data.{' '}
          <Link to="/privacy" className="cookie-link">Learn more</Link>
        </p>
        <div className="cookie-actions">
          <button className="cookie-btn-decline" onClick={decline}>Decline</button>
          <button className="cookie-btn-accept" onClick={accept}>Accept</button>
        </div>
      </div>
    </div>
  );
}
